import { render, staticRenderFns } from "./HorizontalContainer.vue?vue&type=template&id=ea055170"
import script from "./HorizontalContainer.vue?vue&type=script&lang=js"
export * from "./HorizontalContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports